import * as R from 'ramda';

import { RollFunctionType } from '../types/RollFunction'; 

/**
 * Roll of 1d6
 */
export const d6 = () => Math.floor(Math.random() * 6) + 1;

/**
 * Roll a custom 1d6
 * @param die Custom roll function
 */
export const rollDie = (die: RollFunctionType) => die(d6());

/**
 * Roll a number of custom d6's
 * @param die Custom roll function
 * @param numDice The number of custom dice to roll
 */
export const rollDice = (die: RollFunctionType, numDice: number) => {
  let result = [];
  for (let i=0; i<numDice; i++) {
    result.push(rollDie(die));
  }
  return result;
};

/**
 * Add together all the dice for one dice input row
 * @param diceResults The results of all dice in a row
 */
export const totalRow = (diceResults: number[][]) => {
  const addPairs = (pair: number[], acc: number[]) => {
    return [pair[0] + acc[0], pair[1] + acc[1]];
  };
  return R.reduce(addPairs, [0, 0], diceResults);
};

/**
 * Add together all the dice rolled at one time
 * @param diceResults The results of all dice rolled at once
 */
export const totalAllRows = (diceResults: number[][][]) => {
  return totalRow(R.unnest(diceResults));
};
